import * as React from "react";
import { Book, Pill, Box, ShoppingCart, Truck } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
const solutions = [{
  title: "Book Industry",
  icon: Book,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663779/img/solution_book_industry.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663779/img/solution_book_industry.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663779/img/solution_book_industry.png-wvc-sizes"
}, {
  title: "Pharmaceutical",
  icon: Pill,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663779/img/solution_pharmaceutical.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663779/img/solution_pharmaceutical.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663779/img/solution_pharmaceutical.png-wvc-sizes"
}, {
  title: "Warehousing",
  icon: Box,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663779/img/solution_warehousing.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663779/img/solution_warehousing.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663779/img/solution_warehousing.png-wvc-sizes"
}, {
  title: "E-commerce",
  icon: ShoppingCart,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663779/img/solution_ecommerce.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663779/img/solution_ecommerce.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663779/img/solution_ecommerce.png-wvc-sizes"
}, {
  title: "Express Delivery",
  icon: Truck,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663779/img/solution_express_delivery.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663779/img/solution_express_delivery.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663779/img/solution_express_delivery.png-wvc-sizes"
}];
export default function KeyFeaturesGrid() {
  return <section data-section-id="252226" id="strategic-solutions" className="w-full py-24 md:py-32 bg-background text-foreground overflow-hidden light">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight mb-4">Solutions</h2>
          <div className="w-20 h-1 bg-primary mx-auto rounded-lg" />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {solutions.map((solution, i) => <Link key={i} data-index={i} to="/" className="block group">
              <Card className="relative h-[400px] md:h-[500px] p-0 overflow-hidden border-none rounded-2xl shadow-lg">
                <div className="absolute inset-0 z-0">
                  <img src={solution.image} data-wvc-srcset={solution.srcset} data-wvc-sizes={solution.sizes} alt={solution.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" loading="lazy" decoding="async" />
                  <div className="absolute inset-0 bg-black/60 group-hover:bg-black/40 transition-colors duration-500" />
                </div>

                <CardContent className="absolute inset-0 flex flex-col justify-end p-6 z-20">
                  <div className="mb-4 transform transition-transform duration-500 group-hover:-translate-y-2">
                    <solution.icon className="w-8 h-8 text-primary mb-4" strokeWidth={1.5} />
                    <h3 className="text-xl font-bold text-white leading-tight">
                      {solution.title}
                    </h3>
                  </div>
                  
                  <div className="w-0 h-0.5 bg-primary transition-all duration-500 group-hover:w-full" />
                </CardContent>
              </Card>
            </Link>)}
        </div>
      </div>
    </section>;
}